<div class="profile-parent-container">
  <div class="container">
    <div class="profile-headline">Your PostGenie profile</div>
    <div class="profile-subheader">
      This information will be used in the creation of your posts.
    </div>
    <div class="row">
      <div class="col-lg">
        <form [formGroup]="profileForm">
          <div class="short-description pb-1">Job Title / Description *</div>
          <div class="pb-4">
            <textarea
              formControlName="jobDescription"
              placeholder="E.g. I am a consultant in M&A and I work with clients in the banking industry"
            ></textarea>
          </div>
          <div class="short-description pb-1">Department *</div>
          <div class="pb-4">
            <textarea
              formControlName="department"
              placeholder="E.g. Marketing, Sales"
            ></textarea>
          </div>
          <div class="short-description pb-1">
            Additional information that we should consider
          </div>
          <div class="pb-4" class="additional-info-textbox">
            <textarea
              formControlName="additionalInfo"
              placeholder="Please add any additional information that we should considered"
              maxlength="{{ additionalInfoMax }}"
            ></textarea>
            <span class="counter"
              >{{ additionalInfoCount }}/{{ additionalInfoMax }}</span
            >
          </div>
          <div class="textarea-container button-right-align w-100">
            <button
              class="btn btn-primary input-element button-bottom w-25"
              (click)="emitProfile()"
              [disabled]="!profileForm.valid"
            >
              Save profile
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
